/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreditHistoryLogDto } from '../../models/credit-history-log-dto';

export interface CreditHistoryLogControllerFindById$Params {
  id: string;
}

export function creditHistoryLogControllerFindById(http: HttpClient, rootUrl: string, params: CreditHistoryLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditHistoryLogDto>> {
  const rb = new RequestBuilder(rootUrl, creditHistoryLogControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditHistoryLogDto>;
    })
  );
}

creditHistoryLogControllerFindById.PATH = '/api/creditHistoryLog/{id}';
